import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from '@mui/material'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ITenderProtocolData } from 'types/final-protocol'

const StyledTableCell = styled(TableCell)(() => ({
  padding: 0,
  width: '100%',

  '& .MuiInputBase-root.MuiOutlinedInput-root': {
    borderRadius: 0,
  },

  '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled': {
    background: 'rgba(128,128,128, 0.1)',
  },
}))

type Props = {
  protocolData: ITenderProtocolData
}

export const SubmitterOrganizationRanksTable = ({ protocolData }: Props) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields } = useFieldArray({
    control,
    name: `submitterOrganizationRanks`,
  })

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: 'fixed',
          background: '#FFF',
          '& td, th': {
            border: '1px solid #ccc',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('ordinal')}</TableCell>
            <TableCell>{t('ranks')}</TableCell>
            <TableCell>{t('supplier-name')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <Typography>{t(`${index + 1}-rank`)}</Typography>
                </TableCell>
                <StyledTableCell>
                  <Controller
                    name={`submitterOrganizationRanks.${index}.orgName`}
                    control={control}
                    render={({ field }) => (
                      <TextField {...field} fullWidth variant="outlined" />
                    )}
                  />
                </StyledTableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
